(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quarterfinal-password"]) return;
  try {
    
  const initializeQuarterfinalCountdown = (countdown) => {
    if (countdown.dataset.qfInitialized === 'true') return;

    countdown.dataset.qfInitialized = 'true';

    const releaseDate = countdown.dataset.releaseDate;
    const releaseTime = countdown.dataset.releaseTime || '00:00';
    const releaseOffset = countdown.dataset.releaseOffset || 'Z';
    const target = Date.parse(`${releaseDate}T${releaseTime}:00${releaseOffset}`);
    const days = countdown.querySelector('[data-qf-days]');
    const hours = countdown.querySelector('[data-qf-hours]');
    const minutes = countdown.querySelector('[data-qf-minutes]');
    const seconds = countdown.querySelector('[data-qf-seconds]');
    let intervalId;

    const display = (element, value) => {
      element.textContent = String(value).padStart(2, '0');
    };

    const update = () => {
      const remaining = Number.isFinite(target) ? Math.max(0, Math.floor((target - Date.now()) / 1000)) : 0;

      display(days, Math.floor(remaining / 86400));
      display(hours, Math.floor((remaining % 86400) / 3600));
      display(minutes, Math.floor((remaining % 3600) / 60));
      display(seconds, remaining % 60);

      if (remaining === 0) {
        countdown.dataset.countdownComplete = 'true';
        if (intervalId) window.clearInterval(intervalId);
      }
    };

    update();

    if (Number.isFinite(target) && target > Date.now()) {
      intervalId = window.setInterval(update, 1000);
    }
  };

  const initializeQuarterfinalCountdowns = (scope = document) => {
    scope.querySelectorAll('[data-qf-countdown]').forEach(initializeQuarterfinalCountdown);
  };

  initializeQuarterfinalCountdowns();

  document.addEventListener('shopify:section:load', (event) => {
    initializeQuarterfinalCountdowns(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
